import ko from "knockout";
import "flow/bindings/intSpaceIfZeroFormatterBinding";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import viewHtml from "./number.html";
import createRequiredObservable from "flow/koHelpers/createRequiredObservable";
import { selectIdAttr } from "flow/koHelpers/selectId";
import { selectLabel, selectPlaceholder } from "flow/koHelpers/selectParam";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { interceptAttributesWithDefaultsIgnoreId } from "flow/koHelpers/interceptAttributes";
import { makeObservableIfNeeded } from "flow/koHelpers/makeObservable";

export interface INumberParams {
    value: KnockoutObservable<number>;
    valueUpdate?: string;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    attr?: MaybeObservableAttributes;
    noUpDownArrows?: MaybeObservable<boolean>;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    metaPlaceholder?: MaybeObservable<string>;
    placeholder?: MaybeObservable<string>;
    alignRight?: boolean;
}

ko.components.register("ko-number", {
    viewModel: function (params: INumberParams) {
        this.value = params.value;
        this.valueUpdate = params.valueUpdate;
        this.required = createRequiredObservable(params.value);
        this.id = selectIdAttr("ko_number", params.attr);
        this.label = selectLabel(params.meta, params.text);
        this.enable = createEnabler(params.enable, params.disable);
        this.noUpDownArrows = makeObservableIfNeeded<boolean>(params.noUpDownArrows, false);
        this.textAlign = params.alignRight ? "right" : undefined;
        this.attributes = interceptAttributesWithDefaultsIgnoreId(
            {
                autocomplete: "off",
                placeholder: selectPlaceholder(params.metaPlaceholder, params.placeholder)
            },
            params.attr
        );
    },
    template: viewHtml,
    synchronous: true
});
